import React, { useState } from "react";
import imageCompression from "browser-image-compression";

export default function HelpdeskForm() {
  const [form, setForm] = useState({ nama: "", email: "", pesan: "" });
  const [foto, setFoto] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      try {
        const options = {
          maxSizeMB: 0.3,       // target maksimal 300KB
          maxWidthOrHeight: 1024, // resize jika lebih besar dari 1024px
          useWebWorker: true,
        };
        const compressedFile = await imageCompression(file, options);
        setFoto(compressedFile);
      } catch (err) {
        console.error("Kompresi gagal:", err);
        setFoto(file); // fallback pakai file asli
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    try {
      const formData = new FormData();
      formData.append("nama", form.nama);
      formData.append("email", form.email);
      formData.append("pesan", form.pesan);
      if (foto) {
        formData.append("file", foto);
      }

const res = await fetch(
  "https://script.google.com/macros/s/AKfycby9PdLTQWQKITul2UupngieXzjMdvPymj3Phbxt0ZOmomRWj71InYpJUrUVRpcJvTtxEg/exec",
  {
    method: "POST",
    body: formData,
  }
);


      if (!res.ok) throw new Error("Gagal kirim");

      setMessage("✅ Pesan berhasil dikirim!");
      setForm({ nama: "", email: "", pesan: "" });
      setFoto(null);
    } catch (err) {
      setMessage("⚠️ Error: " + err.message);
    }

    setLoading(false);
  };

  return (
    <div className="max-w-md mx-auto p-6 bg-white shadow rounded-lg">
      <h2 className="text-xl font-bold mb-4 text-center">Helpdesk</h2>

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block font-medium">Nama</label>
          <input
            type="text"
            name="nama"
            value={form.nama}
            onChange={handleChange}
            className="w-full p-2 border rounded"
            required
          />
        </div>

        <div>
          <label className="block font-medium">Email</label>
          <input
            type="email"
            name="email"
            value={form.email}
            onChange={handleChange}
            className="w-full p-2 border rounded"
            required
          />
        </div>

        <div>
          <label className="block font-medium">Pesan</label>
          <textarea
            name="pesan"
            value={form.pesan}
            onChange={handleChange}
            className="w-full p-2 border rounded"
            rows="4"
            required
          />
        </div>

        <div>
          <label className="block font-medium">Lampiran Foto</label>
          <input type="file" accept="image/*" onChange={handleFileChange} />
        </div>

        <button
          type="submit"
          disabled={loading}
          className="w-full bg-blue-600 text-white py-2 px-4 rounded hover:bg-blue-700 disabled:opacity-50"
        >
          {loading ? "Mengirim..." : "Kirim Pesan"}
        </button>
      </form>

      {message && <p className="mt-4 text-center font-medium">{message}</p>}
    </div>
  );
}
